import React from 'react';
import { useNavigate } from 'react-router-dom';

const HeadSkullPT = () => {
  const navigate = useNavigate();

  return (
    <>
      <style>{`
        .headSkull-page {
          min-height: 100vh;
          width: 100%;
          background: radial-gradient(circle at top left, #e0f2fe 0, #f9fafb 40%, #e5e7eb 100%);
          font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
          color: #0f172a;
        }

        .headSkull-inner {
          max-width: 1200px;
          margin: 0 auto;
          padding: 32px 16px 72px;
        }

        .headSkull-tag {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          padding: 4px 12px;
          border-radius: 999px;
          background: rgba(37, 99, 235, 0.1);
          color: #1d4ed8;
          font-size: 12px;
          font-weight: 600;
          text-transform: uppercase;
          letter-spacing: 0.08em;
          margin-bottom: 10px;
        }

        .headSkull-tag-dot {
          width: 6px;
          height: 6px;
          border-radius: 999px;
          background: #1d4ed8;
        }

        .headSkull-title {
          font-size: clamp(28px, 4vw, 40px);
          font-weight: 800;
          line-height: 1.1;
          margin-bottom: 12px;
        }

        .headSkull-subtitle {
          font-size: 15px;
          max-width: 540px;
          line-height: 1.5;
          color: #4b5563;
        }

        .headSkull-hero {
          display: flex;
          flex-wrap: wrap;
          align-items: center;
          justify-content: space-between;
          gap: 28px;
          padding-bottom: 40px;
          border-bottom: 1px solid rgba(148, 163, 184, 0.4);
        }

        .headSkull-hero-text {
          flex: 1 1 280px;
        }

        .headSkull-hero-image {
          flex: 1 1 260px;
          display: flex;
          justify-content: center;
        }

        .headSkull-hero-image img {
          width: 100%;
          max-width: 420px;
          height: auto;
          border-radius: 24px;
          object-fit: cover;
        }

        .headSkull-highlight-list {
          display: flex;
          flex-wrap: wrap;
          gap: 10px;
          margin: 16px 0 18px;
        }

        .headSkull-highlight-pill {
          padding: 6px 12px;
          border-radius: 999px;
          background: rgba(15, 23, 42, 0.85);
          color: #f9fafb;
          font-size: 12px;
        }

        .headSkull-cta-row {
          display: flex;
          flex-wrap: wrap;
          gap: 10px;
          margin-top: 10px;
        }

        .headSkull-btn-primary,
        .headSkull-btn-secondary {
          border-radius: 999px;
          border: none;
          font-size: 14px;
          padding: 10px 18px;
          cursor: pointer;
          display: inline-flex;
          align-items: center;
          gap: 6px;
          transition: transform 0.12s ease, box-shadow 0.12s ease, background 0.12s ease;
        }

        .headSkull-btn-primary {
          background: #2563eb;
          color: #f9fafb;
          box-shadow: 0 10px 25px rgba(37, 99, 235, 0.35);
        }

        .headSkull-btn-primary:hover {
          transform: translateY(-1px);
          box-shadow: 0 12px 30px rgba(37, 99, 235, 0.45);
        }

        .headSkull-btn-secondary {
          background: rgba(15, 23, 42, 0.05);
          color: #111827;
          border: 1px solid rgba(148, 163, 184, 0.7);
        }

        .headSkull-btn-secondary:hover {
          background: rgba(15, 23, 42, 0.1);
          transform: translateY(-1px);
        }

        .headSkull-hero-small {
          font-size: 11px;
          margin-top: 10px;
          color: #6b7280;
        }

        /* ==== STRIPE SECTIONS (full width, no boxes) ==== */
        .headSkull-stripe {
          padding: 32px 0;
          border-bottom: 1px solid rgba(148, 163, 184, 0.4);
        }

        .headSkull-sectionTitle {
          font-size: 20px;
          font-weight: 700;
          margin-bottom: 8px;
        }

        .headSkull-sectionSubtitle {
          font-size: 13px;
          color: #4b5563;
          margin-bottom: 16px;
        }

        .headSkull-flexRow {
          display: flex;
          flex-wrap: wrap;
          gap: 24px;
          align-items: flex-start;
        }

        .headSkull-flexCol {
          flex: 1 1 260px;
        }

        .headSkull-list {
          list-style: none;
          padding: 0;
          margin: 0;
          display: grid;
          gap: 8px;
        }

        .headSkull-list li {
          font-size: 14px;
          color: #111827;
          display: flex;
          gap: 8px;
        }

        .headSkull-listBullet {
          width: 7px;
          height: 7px;
          border-radius: 999px;
          margin-top: 6px;
          background: #2563eb;
          flex-shrink: 0;
        }

        .headSkull-inlineImage {
          width: 100%;
          max-width: 400px;
          border-radius: 20px;
          object-fit: cover;
        }

        /* TMJ + VISIT FLOW */
        .headSkull-timeline {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));
          gap: 10px;
          margin-top: 10px;
        }

        .headSkull-timelineStep {
          border-radius: 18px;
          padding: 10px 12px;
          background: rgba(15, 23, 42, 0.03);
        }

        .headSkull-timelineLabel {
          font-size: 12px;
          font-weight: 600;
          margin-bottom: 4px;
        }

        .headSkull-timelineText {
          font-size: 12px;
          color: #4b5563;
        }

        /* FULL-WIDTH IMAGE BANNER */
        .headSkull-banner {
          position: relative;
          margin-top: 20px;
          border-radius: 24px;
          overflow: hidden;
        }

        .headSkull-banner img {
          width: 100%;
          height: 220px;
          object-fit: cover;
          display: block;
        }

        @media (min-width: 768px) {
          .headSkull-banner img {
            height: 260px;
          }
        }

        .headSkull-bannerOverlay {
          position: absolute;
          inset: 0;
          background: linear-gradient(90deg, rgba(15, 23, 42, 0.7), transparent 55%);
          display: flex;
          flex-direction: column;
          justify-content: center;
          padding: 18px 20px;
          gap: 8px;
        }

        .headSkull-bannerText {
          color: #e5e7eb;
          font-size: 15px;
          max-width: 420px;
        }

        .headSkull-bannerButtons {
          display: flex;
          flex-wrap: wrap;
          gap: 8px;
          margin-top: 6px;
        }

        .headSkull-bannerButtons button {
          font-size: 12px;
          padding: 7px 12px;
          border-radius: 999px;
          border: none;
          cursor: pointer;
          display: inline-flex;
          align-items: center;
          gap: 4px;
        }

        .headSkull-bannerButtons .primary {
          background: #22c55e;
          color: #022c22;
        }

        .headSkull-bannerButtons .secondary {
          background: rgba(15, 23, 42, 0.2);
          color: #f9fafb;
          border: 1px solid rgba(209, 213, 219, 0.7);
        }

        /* BOTTOM WARNING/CTA */
        .headSkull-bottomStrip {
          margin-top: 28px;
          padding: 16px 14px;
          border-radius: 22px;
          background: #0f172a;
          display: flex;
          flex-wrap: wrap;
          gap: 12px;
          align-items: center;
          justify-content: space-between;
        }

        .headSkull-bottomText {
          font-size: 12px;
          color: #e5e7eb;
          flex: 1 1 240px;
        }

        .headSkull-bottomText strong {
          color: #fef9c3;
        }

        .headSkull-bottomActions {
          display: flex;
          flex-wrap: wrap;
          gap: 8px;
        }

        .headSkull-bottomActions button {
          font-size: 12px;
          padding: 7px 12px;
          border-radius: 999px;
          border: none;
          cursor: pointer;
        }

        .headSkull-bottomActions .primary {
          background: #2563eb;
          color: #f9fafb;
        }

        .headSkull-bottomActions .secondary {
          background: transparent;
          color: #e5e7eb;
          border: 1px solid rgba(148, 163, 184, 0.8);
        }

        /* RESPONSIVE TWEAKS */
        @media (max-width: 640px) {
          .headSkull-title {
            font-size: 26px;
          }
          .headSkull-hero {
            padding-bottom: 28px;
          }
        }
      `}</style>

      <div className="headSkull-page">
        <div className="headSkull-inner">
          {/* ===== HERO (IMAGE + TEXT, FULL WIDTH) ===== */}
          <section className="headSkull-hero">
            <div className="headSkull-hero-text">
              <div className="headSkull-tag">
                <span className="headSkull-tag-dot" />
                Head & Skull Relief with PT
              </div>
              <h1 className="headSkull-title">
                Physical therapy for the head & skull:
                less pressure, clearer days.
              </h1>
              <p className="headSkull-subtitle">
                We focus on the connection between your neck, jaw, posture, and muscles
                so you&apos;re not fighting headaches and pressure all day.
              </p>

              <div className="headSkull-highlight-list">
                <span className="headSkull-highlight-pill">Tension & cervicogenic headaches</span>
                <span className="headSkull-highlight-pill">TMJ / jaw pain & clenching</span>
                <span className="headSkull-highlight-pill">Neck strain that travels upward</span>
              </div>

              <div className="headSkull-cta-row">
                <button
                  className="headSkull-btn-primary"
                  onClick={() => navigate('/appointments')}
                >
                  Book Head & Skull PT →
                </button>
                <button
                  className="headSkull-btn-secondary"
                  onClick={() => navigate('/staff')}
                >
                  Meet our therapists
                </button>
              </div>

              <p className="headSkull-hero-small">
                Not sure where your pain is coming from? Start with an evaluation and ask all your questions.
              </p>
            </div>

            <div className="headSkull-hero-image">
              <img
                src="/content/head-skull/head_skull_hero.png"
                alt="Physical therapist providing gentle head and neck support"
              />
            </div>
          </section>

          {/* ===== STRIPE 1 – COMMON ISSUES + TMJ IMAGE ===== */}
          <section className="headSkull-stripe">
            <div className="headSkull-sectionTitle">What kinds of head & skull problems can PT help?</div>
            <p className="headSkull-sectionSubtitle">
              A lot of “mystery headaches” and jaw pressure actually come from muscle tension,
              joint stiffness, or posture issues that physical therapy can target directly.
            </p>

            <div className="headSkull-flexRow">
              <div className="headSkull-flexCol">
                <ul className="headSkull-list">
                  <li>
                    <span className="headSkull-listBullet" />
                    <span>
                      <strong>Neck-based headaches (cervicogenic):</strong> pain that starts at the base of the skull and
                      wraps toward the forehead or eye.
                    </span>
                  </li>
                  <li>
                    <span className="headSkull-listBullet" />
                    <span>
                      <strong>Tension headaches:</strong> “band-like” pressure around the head, often worse after computer use or stress.
                    </span>
                  </li>
                  <li>
                    <span className="headSkull-listBullet" />
                    <span>
                      <strong>TMJ / jaw pain:</strong> clicking, popping, or aching near the ear when chewing, talking, or clenching.
                    </span>
                  </li>
                  <li>
                    <span className="headSkull-listBullet" />
                    <span>
                      <strong>Neck strain:</strong> stiffness or pulling in the neck that sends pain upward into the skull.
                    </span>
                  </li>
                  <li>
                    <span className="headSkull-listBullet" />
                    <span>
                      <strong>Posture-related pressure:</strong> forward-head posture adding extra load to the upper neck and head.
                    </span>
                  </li>
                </ul>

                <div className="headSkull-cta-row" style={{ marginTop: '16px' }}>
                  <button
                    className="headSkull-btn-primary"
                    onClick={() => navigate('/appointments')}
                  >
                    See if your headache fits →
                  </button>
                  <button
                    className="headSkull-btn-secondary"
                    onClick={() => navigate('/contact')}
                  >
                    Ask a quick question
                  </button>
                </div>
              </div>

              <div className="headSkull-flexCol" style={{ display: 'flex', justifyContent: 'center' }}>
                <img
                  src="/content/head-skull/tmj_focus.jpg"
                  alt="Physical therapist treating TMJ and jaw area"
                  className="headSkull-inlineImage"
                />
              </div>
            </div>
          </section>

          {/* ===== STRIPE 2 – HOW PT HELPS + NECK IMAGE ===== */}
          <section className="headSkull-stripe">
            <div className="headSkull-sectionTitle">How physical therapy actually helps the head & skull</div>
            <p className="headSkull-sectionSubtitle">
              This isn&apos;t “just exercise.” We combine hands-on techniques with simple, repeatable movements
              that are built around your daily life.
            </p>

            <div className="headSkull-flexRow">
              <div className="headSkull-flexCol">
                <img
                  src="/content/head-skull/neck_manual_therapy.jpg"
                  alt="Manual therapy at the base of the skull and neck"
                  className="headSkull-inlineImage"
                />
              </div>

              <div className="headSkull-flexCol">
                <ul className="headSkull-list">
                  <li>
                    <span className="headSkull-listBullet" />
                    <span>
                      <strong>Joint & soft-tissue work:</strong> gentle mobilization for the neck, upper back, and jaw muscles
                      to reduce stiffness and pressure.
                    </span>
                  </li>
                  <li>
                    <span className="headSkull-listBullet" />
                    <span>
                      <strong>Muscle balancing:</strong> calming down overworked muscles and strengthening the ones that hold your head up.
                    </span>
                  </li>
                  <li>
                    <span className="headSkull-listBullet" />
                    <span>
                      <strong>Posture resets:</strong> quick, realistic changes to your desk, phone habits, and sleep positions.
                    </span>
                  </li>
                  <li>
                    <span className="headSkull-listBullet" />
                    <span>
                      <strong>Jaw relaxation training:</strong> strategies to reduce clenching, improve breathing, and give your TMJ a break.
                    </span>
                  </li>
                  <li>
                    <span className="headSkull-listBullet" />
                    <span>
                      <strong>Short home plan:</strong> 2–4 key moves you can remember — not a 20-exercise packet.
                    </span>
                  </li>
                </ul>

                <div className="headSkull-cta-row" style={{ marginTop: '16px' }}>
                  <button
                    className="headSkull-btn-primary"
                    onClick={() => navigate('/appointments')}
                  >
                    Start with one visit →
                  </button>
                  <button
                    className="headSkull-btn-secondary"
                    onClick={() => navigate('/insurance')}
                  >
                    Check my insurance
                  </button>
                </div>
              </div>
            </div>
          </section>

          {/* ===== STRIPE 3 – TMJ + VISIT FLOW (TEXT FOCUSED) ===== */}
          <section className="headSkull-stripe">
            <div className="headSkull-flexRow">
              <div className="headSkull-flexCol">
                <div className="headSkull-sectionTitle">TMJ / jaw pain and the head</div>
                <p className="headSkull-sectionSubtitle">
                  The jaw joint sits right in front of the ear and shares muscles with your neck and skull.
                  When it&apos;s irritated, your head often feels it too.
                </p>

                <ul className="headSkull-list">
                  <li>
                    <span className="headSkull-listBullet" />
                    <span>
                      <strong>Common TMJ signs:</strong> clicking, popping, locking, pain with chewing, or headaches near the temples.
                    </span>
                  </li>
                  <li>
                    <span className="headSkull-listBullet" />
                    <span>
                      <strong>PT focus:</strong> jaw muscle release, joint mobilization, neck/posture work, and bite-friendly movement patterns.
                    </span>
                  </li>
                  <li>
                    <span className="headSkull-listBullet" />
                    <span>
                      <strong>Goal:</strong> calm the joint, reduce pain, and help your jaw move comfortably again.
                    </span>
                  </li>
                </ul>

                <div className="headSkull-cta-row" style={{ marginTop: '16px' }}>
                  <button
                    className="headSkull-btn-primary"
                    onClick={() => navigate('/appointments')}
                  >
                    TMJ-focused evaluation →
                  </button>
                  <button
                    className="headSkull-btn-secondary"
                    onClick={() => navigate('/staff')}
                  >
                    Find a TMJ therapist
                  </button>
                </div>
              </div>

              <div className="headSkull-flexCol">
                <div className="headSkull-sectionTitle">What a visit might look like</div>
                <p className="headSkull-sectionSubtitle">
                  Every plan is tailored, but most sessions follow a simple, calm rhythm:
                </p>

                <div className="headSkull-timeline">
                  <div className="headSkull-timelineStep">
                    <div className="headSkull-timelineLabel">1. Listen & learn</div>
                    <div className="headSkull-timelineText">
                      You explain your pain, triggers, and what you&apos;re worried about.
                    </div>
                  </div>
                  <div className="headSkull-timelineStep">
                    <div className="headSkull-timelineLabel">2. Gentle exam</div>
                    <div className="headSkull-timelineText">
                      We look at neck motion, jaw movement, posture, and key muscles around the skull.
                    </div>
                  </div>
                  <div className="headSkull-timelineStep">
                    <div className="headSkull-timelineLabel">3. First relief</div>
                    <div className="headSkull-timelineText">
                      You try one or two hands-on techniques and a simple movement to repeat at home.
                    </div>
                  </div>
                  <div className="headSkull-timelineStep">
                    <div className="headSkull-timelineLabel">4. Short plan</div>
                    <div className="headSkull-timelineText">
                      Together we decide how often to come in and what to focus on first.
                    </div>
                  </div>
                </div>

                <div className="headSkull-cta-row" style={{ marginTop: '16px' }}>
                  <button
                    className="headSkull-btn-primary"
                    onClick={() => navigate('/appointments')}
                  >
                    Book a head & jaw visit →
                  </button>
                </div>
              </div>
            </div>
          </section>

          {/* ===== FULL-WIDTH BANNER WITH CLINIC IMAGE ===== */}
          <section className="headSkull-stripe">
            <div className="headSkull-banner">
              <img
                src="/content/head-skull/clinic_environment.jpg"
                alt="Bright physical therapy clinic environment"
              />
              <div className="headSkull-bannerOverlay">
                <div className="headSkull-bannerText">
                  Your visit happens in a bright, calm clinic space designed
                  to feel safe and comfortable — not rushed or crowded.
                </div>
                <div className="headSkull-bannerButtons">
                  <button
                    className="primary"
                    onClick={() => navigate('/appointments')}
                  >
                    Schedule my visit →
                  </button>
                  <button
                    className="secondary"
                    onClick={() => navigate('/office')}
                  >
                    See locations
                  </button>
                  <button
                    className="secondary"
                    onClick={() => navigate('/contact')}
                  >
                    Message our front desk
                  </button>
                </div>
              </div>
            </div>
          </section>

          {/* ===== BOTTOM WARNING + FINAL CTA ===== */}
          <section className="headSkull-stripe">
            <div className="headSkull-bottomStrip">
              <div className="headSkull-bottomText">
                If your head or jaw pain is severe, sudden, or feels very different than usual,{" "}
                <strong>seek emergency or medical care first.</strong> Physical therapy is part of your care
                team and does not replace medical evaluation.
              </div>
              <div className="headSkull-bottomActions">
                <button
                  className="primary"
                  onClick={() => navigate('/appointments')}
                >
                  Schedule head & neck PT
                </button>
                <button
                  className="secondary"
                  onClick={() => navigate('/contact')}
                >
                  Talk to our team
                </button>
              </div>
            </div>
          </section>
        </div>
      </div>
    </>
  );
};

export default HeadSkullPT;
